import { useTranslation } from 'react-i18next'

const LOCALES = [
  { code: 'uz', label: 'Oʻz' },
  { code: 'ru', label: 'Ру' },
  { code: 'en', label: 'EN' },
] as const

export function LangSwitcher() {
  const { i18n } = useTranslation()
  return (
    <div className="flex gap-1 text-xs">
      {LOCALES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => i18n.changeLanguage(code)}
          className={
            i18n.resolvedLanguage === code
              ? 'rounded bg-slate-900 px-2 py-1 text-white'
              : 'rounded border border-slate-300 px-2 py-1 text-slate-600 hover:bg-slate-100'
          }
        >
          {label}
        </button>
      ))}
    </div>
  )
}
